// removed by extract-text-webpack-plugin
module.exports = {"list_grid__item":"src-components-ArticleItem----ArticleItem-module---list_grid__item---1RuCu","list_grid__category":"src-components-ArticleItem----ArticleItem-module---list_grid__category---1e-SF","list_grid__info":"src-components-ArticleItem----ArticleItem-module---list_grid__info---1wrg3","date":"src-components-ArticleItem----ArticleItem-module---date---2jU6z","show_more":"src-components-ArticleItem----ArticleItem-module---show_more---385kI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ArticleItem/ArticleItem.module.scss
// module id = 789
// module chunks = 243122681061137